export const pages = [
  { title: "Reports", url: "/" },
  { title: "Games", url: "/games" },
  { title: "Order List", url: "/order-list" },
  { title: "Users", url: "/users" },
  { title: "Advertisement", url: "/advertisement" },
  // { title: "Onboarding", url: "/onboarding" },
];
